import { render, staticRenderFns } from "./MovieBackdrop.vue?vue&type=template&id=b5790f9a&scoped=true&"
import script from "./MovieBackdrop.vue?vue&type=script&lang=js&"
export * from "./MovieBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./MovieBackdrop.vue?vue&type=style&index=0&id=b5790f9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5790f9a",
  null
  
)

export default component.exports